import styles from "./index.module.scss";

const ToggleInput = ({name, checked, checkboxOnChange, depth, hasChildren}) => {
  let title = "";
  if (name === "FogActive") title = "Active";
  if (name === "AudioAutoplay") title = "Autoplay";
  if (name === "CameraEnabled") title = "Enabled";
  else title = name;

  return (
    <div
      className={`${styles.container} ${depth === 1 ? styles.depth_1 : depth === 2 ? styles.depth_2 : ""} ${hasChildren && styles.bright}`}
    >
      <p className={styles.title}>{title}</p>
      <label className={styles.switch} htmlFor={`properties__checkbox-input--${name}`}>
        <input
          type="checkbox"
          id={`properties__checkbox-input--${name}`}
          name={name}
          checked={checked}
          onChange={e => checkboxOnChange(name, e)}
        />
        <span className={`${styles.slider} ${styles.round}`}></span>
      </label>
    </div>
  );
};

export default ToggleInput;
